<div class="page center">
  <div class="login-card">
    <div style="float: right;" class="eyebrow">VisitoCare</div>
    <!-- <h1>Create account</h1> -->
    <div style="margin-top: 1cm; margin-bottom: 1cm;">
        <h2>Signup</h2>
    </div>

    <label>Role</label>
    <select [(ngModel)]="role">
      <option value="doctor">Doctor</option>
      <!-- <option value="medical assistant">Medical Assistant (Not Available) </option> -->
      <option value="patient">Patient </option>
    </select>
    <label>Name</label><input [(ngModel)]="name">
    <label>Email</label><input [(ngModel)]="email">
    <label>Phone</label><input [(ngModel)]="phone">
    <label>Password</label><input [(ngModel)]="password" type="password">
    <label>Confirm Password</label><input [(ngModel)]="confirmPassword" type="password">
    <div style="margin-top:20px">
    <button (click)="signup()" >Create Account</button>
    <div style="float: right; margin-top:20px">
      <div class="error" *ngIf="error">{{ error }}</div>
      <div class="small" *ngIf="message">{{ message }}</div>
      <div class="small" *ngIf="verifyLink" style="margin-top:10px">
          Verification link: <a class="link" [href]="verifyLink">{{ verifyLink }}</a>
      </div>
      </div>
      </div>
    <div class="small" style="margin-left:5px; margin-top: 20px;"><a class="link" routerLink="/login">Back to login</a></div>
  </div>
</div>
